import { render, staticRenderFns } from "./LinkOverlay.vue?vue&type=template&id=f523703c&scoped=true&"
import script from "./LinkOverlay.vue?vue&type=script&lang=js&"
export * from "./LinkOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LinkOverlay.vue?vue&type=style&index=0&id=f523703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f523703c",
  null
  
)

export default component.exports